import React from 'react';
import { useParams } from 'react-router';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { CompanyAccountComponent } from '../../../types/account';
import AppNavbar from '../../../components/AppNavbar';
import LoanSimulationDetail from '../../../features/account/LoanSimulationDetail';
import { getPLRSimulation } from '../../../queries/account';
import ViewTitle from '../../../components/ViewTitle';

type LoanSimulationIdParams = {
  loanSimulationId: string,
}

export default function CompanyAnswerLoanSimulationDetail(props:CompanyAccountComponent) {
  const { token, companyName } = props;
  const { loanSimulationId } = useParams<LoanSimulationIdParams>();
  const {
    plrSimulation,
    plrSimulationLoading,
    plrSimulationError,
  } = getPLRSimulation(token, loanSimulationId);

  return (
    <AppNavbar title={companyName} hideNavigation>
      <>
        <Grid
          container
        >
          <ViewTitle
            title="Aprobación de crédito pendiente"
            xs={8}
            md={8}
            lg={4}
          />

        </Grid>
        {plrSimulationError
        && <Typography>¡Ha ocurrido un error! Por favor contáctanos</Typography>}
        {!plrSimulationError
        && plrSimulationLoading && <CircularProgress size={50} />}
        {!plrSimulationError && !plrSimulationLoading && plrSimulation
          && (
          <LoanSimulationDetail
            plr={plrSimulation.preLoanRequest}
            simulation={plrSimulation.simulation}
            token={token}
            loanSimulationId={loanSimulationId}
          />
          )}
      </>
    </AppNavbar>

  );
}
